import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-928e5d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redFlushDetail__info" }
const _hoisted_2 = { class: "redFlushDetail__item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票抬头：", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "redFlushDetail__item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票类型：", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "redFlushDetail__item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票号：", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "redFlushDetail__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票金额：", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "redFlushDetail__item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票来源：", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "redFlushDetail__item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "红冲方式：", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "redFlushDetail__item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "红冲备注：", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "redFlushDetail__item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "申请人：", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "redFlushDetail__item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "红冲状态：", -1))
const _hoisted_28 = { class: "value" }
const _hoisted_29 = {
  key: 0,
  class: "redFlushDetail__item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "红字发票流水号：", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = {
  key: 1,
  class: "redFlushDetail__item"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "失败原因：", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "redFlushDetail__progress" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "redFlushDetail__progress-title" }, "处理进度：", -1))
const _hoisted_37 = { class: "redFlushDetail__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    title: "红冲详情",
    width: "560px",
    footer: null,
    onCancel: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.detail.invoiceTitle || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.invoiceType || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.detail.invoiceNo || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.detail.invoiceFee !== null && _ctx.detail.invoiceFee !== undefined && _ctx.detail.invoiceFee !== '' ? `¥${_ctx.formatWithIntl(_ctx.detail.invoiceFee)}` : '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.detail.invoiceSource || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.detail.redFlushMode || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.detail.redFlushRemark || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.detail.applicantPhone || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.detail.redFlushStatus || '--'), 1)
            ]),
            (_ctx.detail.invoiceStatus === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.detail.redSerialNo || '--'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.detail.invoiceStatus === 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.detail.failReason || '--'), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_a_table, {
              class: "redFlushDetail__table",
              size: "small",
              "row-key": (record, index) => index,
              columns: _ctx.progressColumns,
              "data-source": _ctx.detail.progress || [],
              pagination: false
            }, null, 8, ["row-key", "columns", "data-source"])
          ])
        ]),
        _: 1
      }, 8, ["spinning"]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}